import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/mergeMap';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ToasterService } from "angular2-toaster";
import { LoanService } from '../../shared-component/service/loan/loan.service';
import { UtilService } from '../../util/util.service';
import { WindowRefService } from '../terms-of-service/window.service';
import { environment } from '../../../environments/environment';
import { Slider } from '../../../assets/js/img-slider';

@Component({
  selector: 'app-kyc',
  templateUrl: './kyc.component.html',
  styleUrls: ['./kyc.component.scss']
})
export class KycComponent implements OnInit {

  @ViewChild('videoPlayer') videoPlayer!: ElementRef;
  @ViewChild('recordedVideo') recordedVideo!: ElementRef;

  public mediaStream: MediaStream | null = null;
  showVideoPopup = false;
  public mediaRecorder: any = null;
  public chunks: Blob[] = [];
  public isCameraStarted = false;
  public isRecording = false;
  public timer: number = 0;
  public timerInterval: any;
  public randomNumber: number;
  public showCamera: boolean = false
  public playCamera: boolean = false
  public cameraInUse: boolean = false

  private token: string;
  public showselfieButton: boolean = false;
  public preview: boolean = false;
  public deviceType: string;
  public form: FormGroup;
  public loanDetails: any;
  public cKycDetails: any;
  public popupContext: { title: string, file?: string, type: string };
  public selectedDocumentID: any = {};
  public selectedDocumentAddress: any = {};
  public aadharFile: File;
  public showEKycButton: boolean = true;
  public camWidth = 550;
  public kycType = "ekyc";
  public clearChunks: boolean = false;
  public showButtonAfterDelay = false;
  public countDown = 9;
  public micDeviceList: any;
  public micDeviceIndex: number = 0;
  public videoFileSource: any = null;

  @ViewChild('popup') modalTemplate: any;
  @ViewChild('bitlyPopup') popUp: any;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (window.innerWidth < this.camWidth) {
      this.camWidth = window.innerWidth - 10;
    } else {
      this.camWidth = 550;
    }
  }

  public cameraConfig: {
    showCamera: boolean,
    currentEntity: AbstractControl
  } = {
      showCamera: false,
      currentEntity: null
    };

  public documents: any = [{
    name: 'AADHAR',
    label: 'Aadhar',
    front: true,
    back: true,
    type: 'id',
    camera: true,
    addressRequired: false
  }, {
    name: 'VOTER_ID',
    label: 'Voter ID',
    front: true,
    back: true,
    type: 'id',
    camera: true,
    addressRequired: false
  }, {
    name: 'DRIVING_LICENSE',
    label: 'Driving Licence',
    front: true,
    back: true,
    type: 'id',
    camera: true,
    addressRequired: false
  }, {
    name: 'PASSPORT',
    label: 'Passport',
    front: true,
    back: true,
    type: 'id',
    camera: true,
    addressRequired: false
  }, {
    name: 'PAN',
    label: 'PAN',
    front: true,
    back: false,
    type: 'id',
    camera: true,
    addressRequired: true
  }, {
    name: 'PUBLIC_LTD_COMPANY',
    label: 'Public Limited Company',
    front: true,
    back: false,
    type: 'id',
    camera: true,
    addressRequired: true
  }, {
    name: 'OTHER',
    label: 'Other',
    front: true,
    back: false,
    type: 'id',
    camera: true,
    addressRequired: true
  }, {
    name: 'UTILITY_BILL',
    label: 'Utility Bill',
    front: true,
    back: false,
    type: 'address',
    camera: true
  }, {
    name: 'BANK_STATEMENT',
    label: 'Bank Statement',
    front: true,
    back: false,
    type: 'address',
    camera: true
  }, {
    name: 'RENTAL_AGREEMENT',
    label: 'Rental Agreement',
    front: true,
    back: false,
    type: 'address',
    camera: true
  }, {
    name: 'LEASE_AGREEMENT',
    label: 'Lease agreement',
    front: true,
    back: true,
    type: 'address',
    camera: false
  }];

  private addressProofSubscriber = null;
  public documentUploadRequired: boolean;
  public digio: any;
  public crd: any = {};
  public havePopupBlockers: any = false;

  constructor(
    public router: Router,
    public fb: FormBuilder,
    public modalService: NgbModal,
    private toasterService: ToasterService,
    public loanService: LoanService,
    public deviceService: DeviceDetectorService,
    public activeRoute: ActivatedRoute,
    private utilService: UtilService,
    private winRef: WindowRefService
  ) {
    this.findDeviceType();
    this.activeRoute.data.subscribe(res => {
      this.loanDetails = res.loanDetail;
      this.cKycDetails = {};
      try {
        if (this.loanDetails && this.loanDetails.CkycRecord) {
          this.cKycDetails = JSON.parse(this.loanDetails.CkycRecord.cKyc);
        }
      } catch (e) {
        this.cKycDetails = {};
      }

      if (this.loanDetails.cKyc) {
        this.kycType = "ckyc";
      } else if (this.loanDetails.Customer.eKyc) {
        this.kycType = "ekyc";
      } else {
        this.kycType = "offlinekyc";
      }
      //JSON.parse(this.loanDetails.CkycRecord.cKyc)
      this.token = this.loanDetails.token;
      this.documentUploadRequired = this.loanDetails && this.loanDetails.forceDocumentUpload && !this.loanDetails.kycCompleted;
      this.initializeForm();
    });
  }

  ngOnInit() {
    this.utilService.getCurrentPosition(this);

    if (this.loanDetails.Customer.DigioEkycRequest &&
      this.loanDetails.Customer.DigioEkycRequest.eKycRequestId &&
      !this.loanDetails.Customer.CustomerEKyc && this.loanDetails.organizationId != 2) {
      this.loanService.checkEkycStatus(this.token, this.loanDetails.Customer.DigioEkycRequest.eKycRequestId).subscribe((res: any) => {
        if (res.data.capture) {
          this.eKycResponseHandler({ message: "KYC Process Completed." });
        }
      }, error => {
        this.showEKycButton = true;
        this.toasterService.pop('error', '', error.message);
      });
    }


    this.havePopupBlockers = false;
    let popup = window.open("https://customer.techfino.in", null, "width:0;height:0");
    if (!popup) {
      this.havePopupBlockers = true;
    } else {
      popup.close();
    }
  }

  showLocationSliderView() {
    setTimeout(function () { Slider('.slide'); }, 1000);
  }

  findDeviceType() {
    if (this.deviceService.isMobile()) {
      this.deviceType = 'mobile';
    }
    if (this.deviceService.isTablet()) {
      this.deviceType = 'tablet';
    }
    if (this.deviceService.isDesktop()) {
      this.deviceType = 'desktop';
    }
  }

  get password() {
    return this.form.get('password');
  }

  get aadhar() {
    return this.form.get('aadhar');
  }

  get offlineKYC() {
    return this.form.get('offlineKYC');
  }

  get eKYC() {
    return this.form.get('eKYC');
  }

  public options: any = {
    environment: environment.DIGIO_ENVIRONMENT,
    logo: environment.COMPANY_LOGO,
    theme: {
      primaryColor: '#3D3BEE',
      secondaryColor: '#3D3BEE'
    },
    callback: ((response: any) => {
      if (!response.hasOwnProperty("error_code")) {
        this.eKycResponseHandler(response);
      }
      if (response.error_code == "CANCELLED") {
        this.showEKycButton = true;
      }
    }),
  };

  initiateEkycRequest() {
    this.showEKycButton = false;
    if (this.loanDetails.organizationId == 2) {
      this.loanService.sendAvanseEkycRequest(this.token).subscribe((res: any) => {
        let avanseKycUrl = 'https://' + res.data.response.link;
        window.location.href = avanseKycUrl;
      }, error => {
        this.showEKycButton = true;
        this.toasterService.pop('error', '', error.message);
      });
    }
    else {
      this.loanService.sendEkycRequest(this.token).subscribe((res: any) => {
        var digio = new this.winRef.nativeWindow['Digio'](this.options);
        digio.init();
        digio.submit(res.data.Customer.DigioEkycRequest.eKycRequestId, this.loanDetails.Customer.mobile, res.data.Customer.DigioEkycRequest.eKycAccessTokenId);
      }, error => {
        this.showEKycButton = true;
        this.toasterService.pop('error', '', error.message);
      });
    }
  }

  async eKycResponseHandler(res: any) {
    const details = this.crd.data;
    this.loanService.updateEkycResponse(this.token, { ...res, ...details }).subscribe((res: any) => {
      window.location.reload();
    }, error => {
      this.showEKycButton = true;
      this.toasterService.pop('error', '', error.message);
    });
  }

  initializeForm() {
    this.form = this.fb.group({
      eKYC: ['1', Validators.compose([Validators.required])],
      offlineKYC: ['0', Validators.compose([Validators.required])]
    });

    if (this.loanDetails.Customer.eKyc || this.loanDetails.cKyc) {
      this.form.patchValue({
        eKYC: 1,
        offlineKYC: 0
      });
      this.selfieUploading();
    } else if (!this.loanDetails.Customer.eKyc) {
      this.documentUploading();
      // if (this.documentUploadRequired) this.documentUploading();
      this.form.patchValue({
        eKYC: 0,
        offlineKYC: 1
      })
      this.offlineKYC.valueChanges.subscribe((res) => {
        if (res === '1') {
          this.form.addControl('aadhar', new FormControl('', Validators.compose([Validators.required])));
          this.form.addControl('password', new FormControl('', Validators.compose([Validators.required])));

          this.selectedDocumentID = {};
          if (this.form.get('idProofType')) {
            this.addressProofSubscriber.unsubscribe();
            this.form.removeControl('idProofType');
          }
          if (this.form.get('idProofFront')) this.form.removeControl('idProofFront');
          if (this.form.get('idProofBack')) this.form.removeControl('idProofBack');
          if (this.form.get('addressProofType')) this.form.removeControl('addressProofType');
          if (this.form.get('addressProofFront')) this.form.removeControl('addressProofFront');
          if (this.form.get('addressProofBack')) this.form.removeControl('addressProofBack');
          if (this.form.get('userImage')) this.form.removeControl('userImage');
        }
        else if (res === '0') {
          this.documentUploading();
        }
      });
    }
  }

  selfieUploading() {
    if (this.form.get('aadhar')) this.form.removeControl('aadhar');
    if (this.form.get('password')) this.form.removeControl('password');
    if (this.form.get('idProofType')) this.form.removeControl('idProofType');
    if (this.form.get('idProofFront')) this.form.removeControl('idProofFront');

    this.form.addControl('userImage', new FormControl('', Validators.compose([Validators.required])));
  }

  documentUploading() {
    if (this.form.get('aadhar')) this.form.removeControl('aadhar');
    if (this.form.get('password')) this.form.removeControl('password');

    this.form.addControl('idProofType', new FormControl('', Validators.compose([Validators.required])));
    this.form.addControl('idProofFront', new FormControl('', Validators.compose([Validators.required])));
    this.form.addControl('userImage', new FormControl('', Validators.compose([Validators.required])));

    this.addressProofSubscriber = this.form.get('idProofType').valueChanges.subscribe((o) => {
      this.selectedDocumentID = this.documents.find(val => val.name === o);
      if (this.selectedDocumentID && this.selectedDocumentID.back) {
        this.form.addControl('idProofBack', new FormControl(null, Validators.compose([Validators.required])));
      } else {
        if (this.form.get('idProofBack')) this.form.removeControl('idProofBack');
      }

      if (this.selectedDocumentID && this.selectedDocumentID.addressRequired) {
        this.form.addControl('addressProofType', new FormControl('', Validators.compose([Validators.required])));
        this.form.get('addressProofType').valueChanges.subscribe((o) => {
          this.selectedDocumentAddress = this.documents.find(val => val.name === o);
          if (!this.form.get('addressProofFront')) {
            this.form.addControl('addressProofFront', new FormControl(null, Validators.compose([Validators.required])));
          }
          if (!this.form.get('addressProofBack') && this.selectedDocumentAddress.back) {
            this.form.addControl('addressProofBack', new FormControl(null, Validators.compose([Validators.required])));
          }
          else if (!this.selectedDocumentAddress.back) {
            this.form.removeControl('addressProofBack');
          }
        });
      } else {
        if (this.form.get('addressProofType')) this.form.removeControl('addressProofType');
        if (this.form.get('addressProofFront')) this.form.removeControl('addressProofFront');
      }
    });
  }

  onAadharUpload($event) {
    this.aadharFile = $event.target.files[0];
    this.aadhar.setValue(this.aadharFile ? this.aadharFile.name : '');
  }

  getImageQuality(size) {
    let map = [{
      min: 0,
      max: 100000,
      quality: 0.8
    }, {
      min: 101000,
      max: 500000,
      quality: 0.5
    }, {
      min: 501000,
      max: 1000000,
      quality: 0.3
    }, {
      min: 1001000,
      max: 2000000,
      quality: 0.2
    }].find(o => {
      return size >= o.min && size < o.max;
    });
    if (map) return map.quality;
    return 0.2;
  }


  openFileChooser(entity: AbstractControl, event: HTMLInputEvent, capture?: false) {
    if (event.target.files.length) {
      if (['image/jpeg'].indexOf(event.target.files[0].type) !== -1) {
        const fileName = event.target.files[0].name;
        const reader = new FileReader();
        const img: any = new Image();
        const elem = document.createElement('canvas');

        reader.readAsDataURL(event.target.files[0]);
        reader.onload = () => {
          img.src = reader.result;

          img.onload = () => {
            elem.width = img.width;
            elem.height = img.height;

            const ctx = elem.getContext('2d');

            ctx.drawImage(img, 0, 0, img.width, img.height);
            ctx.canvas.toBlob((blob) => {
              const file = new File([blob], fileName, {
                type: event.target.files[0].type,
                lastModified: Date.now()
              });
              // Set the value
              entity.setValue(file);
              event.target.value = '';
            }, event.target.files[0].type, this.getImageQuality(event.target.files[0].size));
          };

          reader.onerror = error => {
            event.target.value = '';
            entity.setValue(null);
            console.log(error);
          };
        };
      } else {
        entity.setValue(event.target.files[0]);
        event.target.value = '';
      }
    } else {
      entity.setValue(null);
    }
  }

  openCamera(entity: AbstractControl) {
    this.cameraConfig.showCamera = true;
    this.cameraConfig.currentEntity = entity;
  }

  async submitForm() {
    let details = this.crd; //await this.utilService.getDeviceDetails();
    let data = {};
    if (!this.loanDetails.Customer.eKyc && !this.loanDetails.cKyc) {
      if (this.offlineKYC.value == '0') {
        data['aadhar'] = this.aadharFile;
        data['password'] = this.password.value;

        this.loanService.kyc(data, this.token).subscribe(() => {
          // this.router.navigateByUrl(`/loan/process/${this.token}/verifyDetails`);
        }, (errors) => {
          for (let error of errors) {
            if (!this.form.get(error.field)) continue;
            this.form.get(error.field).setErrors({ server: error.message });
            this.toasterService.pop('error', '', error.message);
          }
        });
      }

      if (this.offlineKYC.value == '1') {
        let formData = new FormData();

        formData.append('deviceType', details.data.deviceType);
        formData.append('deviceBrand', details.data.deviceBrand);
        formData.append('deviceModel', details.data.deviceModel);
        formData.append('ipAddress', details.data.ipAddress);
        formData.append('latitude', details.data.latitude);
        formData.append('longitude', details.data.longitude);

        let headers = new HttpHeaders();
        if (this.form.get('idProofType') && this.form.get('idProofType').value) {
          headers = headers.set('idProofType', this.form.get('idProofType').value);
        }

        if (this.form.get('addressProofType') && this.form.get('addressProofType').value) {
          headers = headers.set('addressProofType', this.form.get('addressProofType').value);
        }

        formData.append('idProofFront', this.form.get('idProofFront').value);

        if (this.form.get('idProofBack') && this.form.get('idProofBack').value) {
          formData.append('idProofBack', this.form.get('idProofBack').value);
        }

        if (this.form.get('addressProofFront') && this.form.get('addressProofFront').value) {
          formData.append('addressProofFront', this.form.get('addressProofFront').value);
        }
        if (this.form.get('addressProofBack') && this.form.get('addressProofBack').value) {
          formData.append('addressProofBack', this.form.get('addressProofBack').value);
        }
        if (this.form.get('userImage') && this.form.get('userImage').value) {
          formData.append('userImage', this.form.get('userImage').value);
        }

        formData.append('kycType', "offline");

        this.loanService.documents(formData, this.token, headers).subscribe(() => {
          this.router.navigateByUrl(`/loan/process/${this.token}/enach`, { replaceUrl: true });
        }, (errors) => {
          for (let error of errors) {
            if (error.field === 'idprooftype') {
              this.form.get('idProofType').setErrors({ server: error.message });
            }
            if (error.field === 'addressprooftype') {
              this.form.get('addressProofType').setErrors({ server: error.message });
            }
            if (!this.form.get(error.field)) continue;
            this.form.get(error.field).setErrors({ server: error.message });
            this.toasterService.pop('error', '', error.message);
          }
        });
      }
    } else if (this.loanDetails.Customer.eKyc) {
      if (this.eKYC.value == '1') {
        let formData = new FormData();

        if (this.form.get('userImage') && this.form.get('userImage').value) {
          formData.append('userImage', this.form.get('userImage').value);
        }
        formData.append('kycType', "ekyc");

        this.loanService.uploadPhoto(this.token, formData).subscribe(() => {
          this.router.navigateByUrl(`/loan/process/${this.token}/enach`, { replaceUrl: true });
        });
      }
    }
    else if (this.loanDetails.cKyc) {
      let formData = new FormData();

      if (this.form.get('userImage') && this.form.get('userImage').value) {
        formData.append('userImage', this.form.get('userImage').value);
      }
      // Create a file from the recorded video data
      const videoBlob = new Blob(this.chunks, { type: 'video/webm' });
      let videoFile = new File([videoBlob], 'recorded_video.webm', { type: 'video/webm' });
      if (this.videoFileSource) {
        videoFile = new File(this.videoFileSource, 'recorded_video.webm', { type: 'video/webm' });
      }

      // Append the video file to the form data
      formData.append('videoDocument', videoFile);

      if (details.data.deviceType || details.data.latitude) {
        if (details.data.deviceType) {
          formData.append('deviceType', details.data.deviceType);
        }
        if (details.data.deviceBrand) {
          formData.append('deviceBrand', details.data.deviceBrand);
        }
        if (details.data.deviceModel) {
          formData.append('deviceModel', details.data.deviceModel);
        }
        if (details.data.ipAddress) {
          formData.append('ipAddress', details.data.ipAddress);
        }
        if (details.data.latitude) {
          formData.append('latitude', details.data.latitude);
        }
        if (details.data.longitude) {
          formData.append('longitude', details.data.longitude);
        }
      }
      
      // Append the otp to the form data
      formData.append('OTP', this.randomNumber.toString());
      formData.append('kycType', "ckyc");

      this.chunks = [];

      this.loanService.uploadPhoto(this.token, formData).subscribe(() => {
        this.router.navigateByUrl(`/loan/process/${this.token}/enach`, { replaceUrl: true });
      }, (errors) => {
        for (let error of errors) {
          this.toasterService.pop('error', '', error.message);
        }
      });
    }
  }

  loadVideoFile(event) {
    if (((event.target.files[0].size / 1024) / 1024) > 15) {
      this.toasterService.pop('error', '', "Recorded file it too large");
      return false;
    }

    this.chunks = event.target.files;
    this.preview = true;
    this.closeVideoPopup
  }

  // Generate a random 6-digit number
  generateRandomNumber() {
    const min = 100000; // Minimum 6-digit number
    const max = 999999; // Maximum 6-digit number
    this.randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
  }

  showFile(file: File | null, title: string) {
    if (this.showCamera || this.cameraConfig.showCamera) return;
    if (file) {
      this.popupContext = { title: title, type: file.type };
      this.getDataURL(file).subscribe(data => {
        this.popupContext.file = data;
      });
      this.modalService.open(this.modalTemplate);
    }
  }

  getDataURL(file: File) {
    return Observable.create(observer => {
      if (!file) return observer.next(null);

      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        observer.next(reader.result);
      };
      reader.onerror = function (error) {
        observer.next(null);
        console.log('Error: ', error);
      };
    });
  }

  removeDataID() {
    this.form.get('idProofFront').setValue('');
    if (this.form.get('idProofBack')) {
      this.form.get('idProofBack').setValue('');
    }
  }

  removeDataAddress() {
    if (this.form.get('addressProofFront')) {
      this.form.get('addressProofFront').setValue('');
    }
    if (this.form.get('addressProofBack')) {
      this.form.get('addressProofBack').setValue('');
    }
  }

  getAllErrors(form: FormGroup | FormArray): { [key: string]: any; } | null {
    let hasError = false;
    const result = Object.keys(form.controls).reduce((acc, key) => {
      const control = form.get(key);
      const errors = (control instanceof FormGroup || control instanceof FormArray)
        ? this.getAllErrors(control)
        : control.errors;
      if (errors) {
        acc[key] = errors;
        hasError = true;
      }
      return acc;
    }, {} as { [key: string]: any; });
    return hasError ? result : null;
  }

  open(content) {
    this.modalService.open(content);
  }

  openPopup() {
    this.loanService.sendPhotoLink(this.token).subscribe(() => {
      this.open(this.popUp);
    });
  }

  startDelayTimer() {
    const timer = setInterval(() => {
      this.countDown -= 1;
      if (this.countDown <= 0) {
        clearInterval(timer);
        this.showButtonAfterDelay = true;
      }
    }, 1300);
  }

  confirmToeKyc() {
    this.showselfieButton = true;
  }

  async speakText() {
    window.speechSynthesis.cancel();

    const text = "Please speak the sentence written on screen to complete video K Y C, Click on record button once you are ready.";
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.rate = 0.75;

    const voices = window.speechSynthesis.getVoices();
    const desiredVoice = voices.find(voice => voice.name === 'Rishi');
    if (desiredVoice) {
      utterance.voice = desiredVoice;
    } else {
      console.log('Desired voice not found.');
    }
    window.speechSynthesis.speak(utterance);
  }

  async startCamera() {
    this.countDown = 9;
    this.showButtonAfterDelay = false;
    this.startDelayTimer();
    navigator.mediaDevices.enumerateDevices()
      .then((devices) => {
        this.micDeviceList = devices.filter(e => e.kind == 'audioinput')
        let constraints = {
          video: true,
          audio: true
          // audio: {
          //   deviceId: { exact: this.micDeviceList[this.micDeviceIndex].deviceId },
          //   channelCount: { min: 1, ideal: 2 },
          //   volume: 1,
          //   echoCancellation: true,
          //   autoGainControl: true,
          //   volumeControl: true,
          //   disableLocalEcho: true,
          //   autoGainControlExact: true
          // }
        }

        navigator.mediaDevices.getUserMedia(constraints)
          .then(stream => {
            let track = stream.getAudioTracks()[0]
            track.addEventListener('mute', () => {
              if (this.isRecording) this.closeOngoingRecording();
              this.toasterService.pop('error', '', 'Mic Muted, Please Turn On Mic')
            })
            track.addEventListener('ended', () => {
              this.toasterService.pop('error', '', 'Stream Ended')
            })
            track.addEventListener('unmute', () => {
              this.toasterService.pop('success', '', 'Mic is Unmuted')
            })

            if (!track.muted && track.enabled && stream.getVideoTracks()[0].enabled) {
              setTimeout(() => {
                this.speakText();
              }, 100);
              this.generateRandomNumber();
              if (window.innerWidth < this.camWidth) {
                this.camWidth = window.innerWidth - 20;
              } else {
                this.camWidth = 550;
              }
              try {
                let oThat = this;
                setTimeout(async function () {
                  oThat.videoPlayer.nativeElement.oncanplaythrough = function () {
                    oThat.videoPlayer.nativeElement.muted = true;
                  }
                  oThat.mediaStream = stream; //await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
                  oThat.videoPlayer.nativeElement.srcObject = oThat.mediaStream;
                  oThat.videoPlayer.nativeElement.play(); // Start playing the camera stream
                  oThat.isCameraStarted = true;
                }, 200);
              } catch (error) {
                console.error('Error starting the camera:', error);
              }
              this.showCamera = true;
            } else {
              this.mediaStream = stream;
              this.stopCamera();
              if (track.muted) this.toasterService.pop('error', '', "Mic is muted, Please unmute the mic.");
              if (track.enabled) this.toasterService.pop('error', '', "Audio is not enabled, Please enable the mic");
            }
          })
          .catch(err => {
            this.toasterService.pop('error', '', "Please enable cam and mic to recode video.");
            console.log(err)
          });
      })
      .catch(err => {
        console.error(err)
      })
  }

  async startRecording() {
    // Clear the chunks & remove the preview in case the user is recording 2nd video without deleting previous
    this.chunks = [];
    this.preview = false;

    try {
      if (!this.mediaStream) {
        console.error('Camera is not started.');
        return;
      }

      const audioContext = new AudioContext();
      const analyser = audioContext.createAnalyser();

      const audioTracks = this.mediaStream.getAudioTracks();
      const audioSource = audioContext.createMediaStreamSource(new MediaStream(audioTracks));
      audioSource.connect(analyser);

      // Configure analyser settings
      analyser.fftSize = 2048;
      const bufferLength = analyser.frequencyBinCount;
      const dataArray = new Uint8Array(bufferLength);

      // Periodically analyze audio data
      let audioCheckInterval = 10;
      const audioInterval = setInterval(() => {
        audioCheckInterval -= 1;
        analyser.getByteFrequencyData(dataArray);
        const averageAmplitude = dataArray.reduce((sum, value) => sum + value, 0) / bufferLength;
        if (audioCheckInterval == 5) {
          if (averageAmplitude <= 5) {
            this.closeOngoingRecording();
            if (averageAmplitude == 0) {
              this.micDeviceIndex++;
              if (this.micDeviceIndex != this.micDeviceList.length) {
                this.toasterService.pop('error', '', 'No Audio Input, Try Again');
              }
              if (this.micDeviceIndex == this.micDeviceList.length) {
                this.toasterService.pop('error', '', 'No Audio Input, Please Use Different Device/Browser Or Close Other Apps')
                this.micDeviceIndex = 0;
              }
            } else {
              this.toasterService.pop('error', '', 'Please Speak The OTP')
            }
          }
        }
        if (audioCheckInterval == 0) clearInterval(audioInterval);
        // console.log('Average Amplitude', averageAmplitude)
      }, 1000);

      this.mediaRecorder = new window["MediaRecorder"](this.mediaStream);
      this.mediaRecorder.start();
      this.isRecording = true;
      this.clearChunks = false;

      clearTimeout(this.timerInterval);
      this.timer = 10;
      this.timerInterval = setInterval(() => {
        this.timer -= 1;
        if (this.timer === 0) {
          this.preview = true;
          clearInterval(this.timerInterval);
        }
      }, 1000);

      this.mediaRecorder.addEventListener('dataavailable', (event) => {
        if (event.data.size > 0) {
          this.chunks.push(event.data);
        }
        // Clear the chunks if mic is muted while recording the video
        if (this.clearChunks) this.chunks = [];
      });
      setTimeout(() => this.stopRecording(), 10900); // Stop recording after 10 seconds
    } catch (error) {
      console.error('Error starting the recording:', error);
    }
  }

  closeOngoingRecording() {
    this.clearChunks = true;
    this.closeVideoPopup();
  }

  async stopCamera() {
    if (this.mediaStream) {
      this.mediaStream.getTracks().forEach(track => track.stop());
      this.mediaStream = null;
      this.isCameraStarted = false;
    }
  }

  closeVideoPopup() {
    this.showCamera = false;
    this.stopRecording();
    this.stopCamera();
  }

  checkFormValidity() {
    return this.form.get('userImage').value &&
      this.chunks[0];
  }

  async showVideoFile() {
    if (this.showCamera || this.cameraConfig.showCamera) return;
    let oThat = this;
    setTimeout(async function () {
      let videoBlob = new Blob(oThat.chunks, { type: 'video/webm' });
      let videoUrl = URL.createObjectURL(videoBlob);
      oThat.videoPlayer.nativeElement.src = videoUrl;
      oThat.showVideoPopup = true;
      oThat.videoPlayer.nativeElement.play();
    }, 200);
    oThat.playCamera = true;
  }

  async closeVideoFile() {
    this.playCamera = false;
    this.showCamera = false;
  }

  async closeVideoPopFile() {
    this.playCamera = false;
    this.preview = false;
    this.chunks = [];
  }

  async stopRecording() {
    if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
      this.mediaRecorder.stop();
      this.mediaRecorder = null;
      this.isRecording = false;
      this.mediaStream.getAudioTracks()[0].stop();
      this.showCamera = false;
      clearInterval(this.timerInterval);
      this.stopCamera(); // Stop the camera
    }
  }

  downloadVideo() {
    const videoBlob = new Blob(this.chunks, { type: 'video/webm' });
    const videoUrl = URL.createObjectURL(videoBlob);
    const anchor = document.createElement('a');
    anchor.href = videoUrl;
    anchor.download = 'recorded_video.webm';
    anchor.click();
  }

  formatTimer(ms: number): string {
    ms = ms * 1000;
    const minutes: number = Math.floor(ms / 60000);
    const seconds: number = Math.floor((ms % 60000) / 1000);
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  ngOnDestroy() {
    clearInterval(this.timerInterval);
  }
}

interface HTMLInputEvent extends Event {
  target: HTMLInputElement & EventTarget;
}
